// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__vaC1T","withValue":"styles_withValue__6C3zH","inline":"styles_inline__OAMGD"};